import { setCustomNativeDragPreview } from "@atlaskit/pragmatic-drag-and-drop/dist/esm/entry-point/element/set-custom-native-drag-preview.js";
import { preserveOffsetOnSource } from "@atlaskit/pragmatic-drag-and-drop/dist/esm/entry-point/element/preserve-offset-on-source.js";

export const reindexByOrder = (items) =>
  items.map((item, index) => ({ ...item, order: index + 1 }));

export const getDropPosition = ({ input, element }) => {
  const rect = element.getBoundingClientRect();
  return input.clientY - rect.top < rect.height / 2 ? "before" : "after";
};

export const getFinishIndex = ({ startIndex, targetIndex, position }) => {
  if (position === "before") {
    return startIndex < targetIndex ? targetIndex - 1 : targetIndex;
  }

  return startIndex < targetIndex ? targetIndex : targetIndex + 1;
};

export const mountDragPreview = ({ nativeSetDragImage, element, input }) => {
  if (!nativeSetDragImage || !element) {
    return;
  }

  setCustomNativeDragPreview({
    nativeSetDragImage,
    getOffset: preserveOffsetOnSource({ element, input }),
    render: ({ container }) => {
      const clone = element.cloneNode(true);
      if (!(clone instanceof HTMLElement)) {
        return;
      }

      const hiddenInPreview = clone.querySelectorAll(
        "[data-drag-preview-hidden='true']"
      );
      hiddenInPreview.forEach((node) => node.remove());

      const { width } = element.getBoundingClientRect();
      clone.style.width = `${width}px`;
      clone.style.boxSizing = "border-box";
      clone.style.margin = "0";
      clone.style.pointerEvents = "none";
      clone.style.opacity = "0.96";
      clone.style.transform = "scale(0.985)";
      clone.style.borderRadius = "12px";
      clone.style.boxShadow = "0 14px 32px rgba(15, 23, 42, 0.24)";

      container.appendChild(clone);
      return () => {
        clone.remove();
      };
    },
  });
};
